import { Alert, Button, Form } from 'react-bootstrap';
import { FaEye, FaEyeSlash } from 'react-icons/fa';
import { esAlumnoOcultable } from '../../hooks/useAlumnosOcultos';

export const FiltroAlumnosOcultos = ({ visibilidad, cantidad }) => {
  if (!visibilidad.puedeOcultar) return null;
  return (
    <div className="mb-3 p-3 rounded border bg-light">
      <Form.Check
        type="switch"
        id="mostrar-alumnos-ocultos"
        label={`Mostrar alumnos ocultos (${cantidad})`}
        checked={visibilidad.mostrarOcultos}
        onChange={(event) => visibilidad.setMostrarOcultos(event.target.checked)}
      />
      <p className="small text-muted mb-0 mt-1">
        {visibilidad.mostrarOcultos
          ? 'Viendo sólo alumnos ocultos. Desactiva esta opción para volver al listado habitual.'
          : 'Los alumnos ocultos no aparecen en este listado.'}{' '}
        La clasificación se comparte con los demás masters y profesores. Los ocultos y usuarios de prueba no cuentan en las métricas. Conservan su acceso y sus datos.
      </p>
      {visibilidad.error && <Alert variant="danger" className="mt-2 mb-0">{visibilidad.error}</Alert>}
    </div>
  );
};

export const BotonVisibilidadAlumno = ({ alumno, visibilidad }) => {
  if (!visibilidad.puedeOcultar || !esAlumnoOcultable(alumno)) return null;
  const oculto = visibilidad.estaOculto(alumno);
  const nombre = alumno.displayName || alumno.name || alumno.username || alumno.email || alumno.id;
  return (
    <Button
      variant="outline-secondary"
      size="sm"
      disabled={Boolean(visibilidad.actualizandoId)}
      onClick={() => visibilidad.cambiarVisibilidad(alumno)}
      aria-label={`${oculto ? 'Volver a mostrar' : 'Ocultar'} a ${nombre}`}
    >
      {oculto ? <FaEye aria-hidden="true" /> : <FaEyeSlash aria-hidden="true" />}{' '}
      {visibilidad.actualizandoId === alumno.id ? 'Guardando…' : oculto ? 'Marcar como alumno real' : 'Ocultar alumno'}
    </Button>
  );
};
